import type React from 'react';
import { createNamedContext } from '@trinity/chat-components/utils/react';
import type { ProjectTagsActions, TagStateValue } from './interfaces';

export type ProjectTagsCapabilities = {
  canManage: boolean;
};

type ContextValue = {
  projectId: number;
  state: TagStateValue;
  dispatch: React.Dispatch<ProjectTagsActions>;
  capabilities?: ProjectTagsCapabilities;
};

export const TagStateContext = createNamedContext<ContextValue | undefined>(
  undefined,
  'Project.TagState.Context'
);
